import moment from "moment";

moment.locale("en-gb");

export default (date: Date, format = "DD/MM/YYYY") => {
  return date ? moment(date).format(format) : "";
};
